import postal from 'postal';
import React from 'react';

const toggleFollow = {
  channel: 'micro-profile.commands',
  topic: 'follow-status',
};

export default function useSynchronizedFollowStatus({ id, onStatusChanged }) {
  React.useEffect(() => {
    id && onStatusChanged && postal.subscribe({
      ...toggleFollow,
      callback: d => d.id === id && onStatusChanged(d.following),
    });
  }, [id, onStatusChanged]);

  return React.useCallback(
    following => postal.publish({ ...toggleFollow, data: { following, id } }),
    [id],
  );
}
